export const assessmentAreas = [
  {
    id: 'vision',
    title: 'Mobilized Vision',
    description: 'Clarity of organizational identity, purpose, and direction',
    color: 'from-blue-500 to-blue-600',
    icon: '🎯',
    questions: [
      'We know who we are as an organization. We have a clear sense of our identity that is shared by internal stakeholders.',
      'We are clear about what we do.',
      'We are clear about why we do what we do.',
      'Who we serve: if you ask our staff, they will answer with clarity about who our target audience is.',
      'My organization\'s values are clear, meaningful, and evident in our culture.'
    ]
  },
  {
    id: 'businessModel',
    title: 'Business Model',
    description: 'Revenue generation and customer value proposition',
    color: 'from-green-500 to-green-600',
    icon: '📈',
    questions: [
      'We have deep knowledge about our customers.',
      'When we connect with our customers, we offer compelling value.',
      'Our leaders and employees understand how we make money.',
      'We have identified and prioritized key business activities.',
      'We have a clear set of key partners who are vital to our success.'
    ]
  },
  {
    id: 'strategy',
    title: 'Strategy',
    description: 'Competitive positioning and strategic clarity',
    color: 'from-indigo-500 to-indigo-600',
    icon: '🎪',
    questions: [
      'We understand why our customers choose us over the competition.',
      'We allocate our resources to maximize our ability to deliver on our value proposition.',
      'We understand our competitors well enough to articulate our differentiators.',
      'We understand which differentiators matter most to our customers.',
      'We have organizational KPIs that show us whether our strategy is working.'
    ]
  },
  {
    id: 'people',
    title: 'People Strategy',
    description: 'Human capital management and development',
    color: 'from-red-500 to-red-600',
    icon: '👤',
    questions: [
      'Employees know what it looks like to "win" at every level.',
      'Leaders monitor the skills of current staff and plan for future needs.',
      'People leaders are effective at developing and retaining talent.',
      'Our people rapidly adopt best practices.',
      'People at my organization feel they are treated and rewarded fairly.'
    ]
  },
  {
    id: 'leadership',
    title: 'Leadership',
    description: 'Leadership effectiveness and team alignment',
    color: 'from-purple-500 to-purple-600',
    icon: '👥',
    questions: [
      'Leaders in my organization are consistently pulling in the same direction.',
      'Our leaders reliably break down our annual priorities into clear short term priorities.',
      'Our leadership team consistently focuses their people on the most important priorities.',
      'The leadership team holds everyone accountable to meaningful performance standards.',
      'Leaders in my organization give credit to others where it is due.'
    ]
  },
  {
    id: 'operations',
    title: 'Operations',
    description: 'Operational efficiency and process management',
    color: 'from-amber-500 to-amber-600',
    icon: '⚙️',
    questions: [
      'Our people value effectiveness and efficiency.',
      'Meetings are typically productive and purposeful.',
      'We use a defined planning cycle to set priorities.',
      'Our organization monitors performance-relative-to-plan in real time.',
      'We know our margins and staffing needs for any new business.'
    ]
  },
  {
    id: 'technology',
    title: 'Technology',
    description: 'Technology adoption and digital capabilities',
    color: 'from-yellow-500 to-yellow-600',
    icon: '💻',
    questions: [
      'Our employees reliably use our tech to enhance their work.',
      'Our technology makes decision-making faster and more reliable.',
      'Employees rarely need "work-arounds" to side-step technology limitations.',
      'We have a defined process for addressing technology gaps.',
      'We have allocated resources to support technology implementation.'
    ]
  },
  {
    id: 'culture',
    title: 'Culture',
    description: 'Organizational culture and employee engagement',
    color: 'from-emerald-500 to-emerald-600',
    icon: '🌟',
    questions: [
      'My organization\'s identity creates a strong sense of belonging.',
      'We have a clear sense of our history.',
      'Newcomers are quick to learn our stories and values.',
      'Employees have strong positive connections with each other.',
      'Team members feel secure enough to take professional risks.'
    ]
  }
];

export const scaleLabels = [
  { value: 1, label: 'Strongly Disagree' },
  { value: 2, label: 'Disagree' },
  { value: 3, label: 'Somewhat Disagree' },
  { value: 4, label: 'Neutral' },
  { value: 5, label: 'Somewhat Agree' },
  { value: 6, label: 'Agree' },
  { value: 7, label: 'Strongly Agree' }
];

export const functionalRoles = [
  'CEO/President',
  'COO/Operations',
  'CFO/Finance',
  'CTO/Technology',
  'VP/Director',
  'Manager',
  'Team Lead',
  'Individual Contributor',
  'Other'
];

export const businessLifecycleOptions = [
  'Pre-Startup',
  'Startup',
  'Transitional',
  'Mature',
  'Restructure/Turn Around'
];

export const companySizeOptions = [
  '1-4',
  '5-9',
  '10-19',
  '20-49',
  '50-99',
  '100+'
];

export const technologyAdoptionOptions = [
  'Innovators',
  'Early Adopters',
  'Early Majority',
  'Late Majority',
  'Laggards'
];

export const interestedAreasOptions = [
  'Leadership',
  'Strategy',
  'Culture',
  'Vision',
  'Business Model',
  'People',
  'Operations',
  'Technology'
];